<template>
    <div>
        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="batchInModal">
                    <div class="modal-header mb-4">
                        <h5 class="modal-title">
                            {{ batchInModal.name }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                        <div v-if="!batchInModalSigned">
                        <div class="row justify-content-center">
                            <div class="col-10 col-sm-10 col-md-9 col-lg-6">
                                <p class="text">
                                    Prezado(a)
                                    <span>{{ userName }}</span>!
                                </p>
                                <p class="text mb-4">
                                    Clique sobre o nome dos documentos abaixo, leia-os, e clique no
                                    botão Assinar, ao fim da página:
                                </p>
                                <p
                                    class="text"
                                    v-for="signatureUserSent in batchInModal.users_sent"
                                    :key="signatureUserSent.id"
                                    @click="getPdfUnit(signatureUserSent)"
                                    style="cursor: pointer"
                                >
                                    <i class="far fa-file-pdf red"></i>
                                    <span>{{ signatureUserSent.document_name || batchInModal.name }}</span>
                                </p>
                            </div>
                        </div>
                        <pdf
                            :key="componentKey"
                            v-if="signatureUserSent"
                            :src="signatureUserSent.document_http"
                            :page="page"
                            style="width: 100%"
                            :scale.sync="scale"
                            class='document-mb'
                        ></pdf>
                        <div class='row controls' v-show="showControls">
                            <div class="col-4 col-xl-1 offset-xl-2">
                                <button
                                class="item btn btn-secondary btn-block"
                                @click="page -= 1"
                                :disabled="page - 1 == 0"
                                >
                                <i class="fa fa-caret-left"></i>
                                </button>
                            </div>
                            <div class="col-4 col-xl-1 centered page-control-label">
                                {{page}} de {{numPages}}
                            </div>
                            <div class="col-4 col-xl-1">
                                <button
                                class="item btn btn-secondary btn-block"
                                @click="page += 1"
                                :disabled="page == numPages"
                                >
                                <i class="fa fa-caret-right"></i>
                                </button>
                            </div>
                            <div class="col-4 col-xl-2 offset-xl-1">
                                <button class='btn btn-danger btn-block btn-close-modal' type="button" data-dismiss="modal" @click="showControls = false">
                                    Fechar
                                </button>
                            </div>
                            <div class="col-8 col-xl-3 pl-0">
                                <button class="btn btn-sign white" @click="sign">
                                <i class="fas fa-file-signature"></i>Assinar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="batchInModalSigned">
                        <div class="row justify-content-center">
                            <div class="col-10 col-sm-10 col-md-9 col-lg-6">
                                <p class="text">
                                    Prezado(a)
                                    <span>{{ userName }}</span>, você assinou os seguintes documentos:
                                </p>
                                <div class="border-confirm mb-5">
                                    <p class="confirm">
                                        <i class="far fa-check-circle"></i>
                                    </p>
                                    <p class="confirmation">Sua assinatura foi confirmada.</p>
                                    <p class="text-2">
                                        Assinado por
                                        <span>{{ signatureUserSent.user.name }}</span>
                                    </p>
                                </div>
                                <p
                                    class="text"
                                    v-for="signatureUserSent in batchInModal.users_sent"
                                    :key="signatureUserSent.id"
                                    @click="getPdfUnit(signatureUserSent)"
                                    style="cursor: pointer"
                                >
                                    <i class="far fa-file-pdf red"></i>
                                    <span>{{ signatureUserSent.document_name || batchInModal.name }}</span>
                                </p>
                            </div>
                        </div>
                        <pdf
                            :key="componentKey"
                            v-if="signatureUserSent"
                            :src="signatureUserSent.document_http"
                            :page="page"
                            style="width: 100%"
                            :scale.sync="scale"
                            class='document-mb'
                        ></pdf>
                        <div class='row controls' v-show="showControls">
                            <div class="col-4 col-xl-1 offset-xl-2">
                                <button
                                class="item btn btn-secondary btn-block"
                                @click="page -= 1"
                                :disabled="page - 1 == 0"
                                >
                                <i class="fa fa-caret-left"></i>
                                </button>
                            </div>
                            <div class="col-4 col-xl-1 centered page-control-label">
                                {{page}} de {{numPages}}
                            </div>
                            <div class="col-4 col-xl-1">
                                <button
                                class="item btn btn-secondary btn-block"
                                @click="page += 1"
                                :disabled="page == numPages"
                                >
                                <i class="fa fa-caret-right"></i>
                                </button>
                            </div>
                            <div class="col-4 col-xl-2 offset-xl-1">
                                <button class='btn btn-danger btn-block btn-close-modal' type="button" data-dismiss="modal" @click="showControls = false">
                                    Fechar
                                </button>
                            </div>
                            <div class="col-8 col-xl-3 pl-0">
                                <button v-if="!batchInModalSigned" class="btn btn-sign white" @click="sign">
                                    <i class="fas fa-file-signature"></i>Assinar
                                </button>
                                <a v-if="batchInModalSigned" class="btn btn-sign white" :href="signatureUserSent.document_http" target="_blank">
                                    <i class="fas fa-download"></i>Baixar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="!userName">
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-9 col-lg-6">
                    <p class="text-title">
                        Verificar pendências
                    </p>
                    <p class="text">
                        Prezado(a) colaborador(a)!
                    </p>
                    <p class="text">
                        Favor informar os dados abaixo para verificar se existem pendências:
                    </p>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-7 col-lg-4">
                    <div class="form-group">
                        <label>CPF</label>
                        <input type="text" class="form-control" v-model="cpf" v-mask="'###.###.###-##'" inputmode="numeric" />
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-7 col-lg-4">
                    <div class="form-group">
                        <label>Data de Nascimento</label>
                        <input class="form-control" type="text" v-mask="'##/##/####'" v-model="birthDate" />
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-4 col-lg-2">
                    <button class="btn btn-sign white" @click="verify()">
                        <i class="fas fa-search"></i>Verificar pendências
                      </button>
                </div>
            </div>
        </div>
        <div v-show="userName">
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-9 col-lg-6">
                    <p class="text-title">
                        Verificar pendências
                    </p>
                    <p class="text">
                        Prezado(a) {{ userName }},
                    </p>
                    <p class="text" v-if="batches !== null && batches.length">
                        Você possui {{ batches.length }} pendência{{ batches.length > 1 ? 's' : '' }}. Clique abaixo em "Assinar" para concluir a assinatura
                    </p>
                    <p class="centered mt-5 no-pending" v-if="batches !== null && batches.length === 0">
                        <i class='fa fa-check fa-2x mb-4 green fa-check-circle'></i>
                        <br>
                        Você <b>não</b> possui pendências.
                    </p>
                </div>
            </div>
            <div class='row justify-content-center'>
                <div class="col-10 col-sm-10 col-md-9 col-lg-6">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="(batch, index) in batches" :key="index">
                            <div class='row'>
                                <div class='col-sm-12 col-md-8 col-xl-9 mb-3'>
                                    {{ batch.name }}
                                </div>
                                <div class='col-sm-12 col-md-4 col-xl-3'>
                                    <button class='btn btn-success btn-block' data-toggle="modal" data-target=".bd-example-modal-lg" @click="batchToModal(batch)">Assinar</button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pdf from "pdfvuer";
export default {
    data() {
        return {
            scale: "page-width",
            batches: null,
            cpf: '',
            birthDate: '',
            userName: '',
            page: 1,
            numPages: 0,
            count: 0,
            openViewPDF: false,
            viewDoc: {},
            pdfdata: "",
            componentKey: 0,
            signatureUserSent: null,
            batchInModal: null,
            showControls: false,
            batchInModalSigned: false,
        };
    },
    methods: {
        getPdf(signatureUserSent) {
            var self = this;
            self.pdfdata = pdf.createLoadingTask(
                signatureUserSent.document_http
            );
            self.pdfdata.then((pdf) => {
                self.numPages = pdf.numPages;
            });
        },
        getPdfUnit(signatureUserSent) {
            this.signatureUserSent = signatureUserSent
            this.count = this.count + 1;
            var self = this;
            self.openViewPDF = false;
            self.page = 1;
            self.viewDoc = signatureUserSent;
            self.pdfdata = pdf.createLoadingTask(signatureUserSent.document_http);
            self.pdfdata.then((pdf) => {
                self.numPages = pdf.numPages;
            });
            self.openViewPDF = true;
            self.componentKey += 1;
            self.showControls = true
        },
        batchToModal(batch){
            this.batchInModalSigned = false
            this.signatureUserSent = null
            this.componentKey++
            this.batchInModal = batch
        },
        verify() {
          $('#page_loader').show()
          const self = this;
          const api = self.$store.state.api + "signatureusersent/my-pending/"
          const fd = new FormData()
          fd.append('cpf', self.cpf)
          fd.append('birthDate', self.birthDate)
          self.$http
              .post(api, fd)
              .then((response) => {
                  $('#page_loader').hide()
                  self.batches = response.data.batches
                  self.userName = response.data.userName
                  if(self.batchInModalSigned){
                    self.getPdfUnit(self.signatureUserSent)
                  }
              })
              .catch((error) => {
                  $('#page_loader').hide()
                  self.$message("Erro", error.response.data, "error");
              });
        },
        sign() {
            const self = this;
            const api = self.$store.state.api + "signatureusersent/sign";

            swal({
                title: "Geolocalização",
                text:
                "Para assinar o documento, é necessário permitir a utilização da geolocalização do dispositivo",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ok, entendi!",
                showLoaderOnConfirm: true,
                buttons: {
                catch: {
                    text: "Cancelar",
                    value: "cancel",
                    className: "btn-danger",
                },
                confirm: {
                    text: "Ok, entendi!",
                    value: "confirm",
                },
                },
            }).then((value) => {
                switch (value) {
                case "cancel":
                    location.reload();

                case "confirm":
                    if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (pos) {
                        $("#page_loader").show();
                        self.$http
                            .post(api, {
                                unhashedId: self.signatureUserSent.id,
                                geolocation: {
                                    latitude: pos.coords.latitude,
                                    longitude: pos.coords.longitude,
                                },
                                cpf: self.cpf,
                                birthDate: self.birthDate,
                                })
                                .then((response) => {
                                    self.componentKey++
                                    self.batchInModalSigned = true
                                    self.verify()
                                })
                                .catch((error) => {
                                    $("#page_loader").hide();
                                    self.$message("Erro", error.response.data, "error");
                                });
                        },
                        function (error) {
                        if (error.code == error.PERMISSION_DENIED)
                            self.showPermissionDeniedSwal();
                        }
                    );
                    } else {
                    alert("Geolocalização não é suportada neste navegador");
                    return false;
                    }
                    break;
                }
            });
        },
        showPermissionDeniedSwal() {
            swal({
                title: "Permissão para acessar geolocalização",
                text:
                "Para realizar a assinatura, você precisa liberar o acesso à geolocalização, siga estes passos para desbloquear: \n\n" +
                "1 - Certifique-se de abrir esta página utilizando o browser/navegador e clique em Configurações\n" +
                "2 - Clique em Configurações do site\n" +
                "3 - Clique em Local\n" +
                "4 - Na lista de bloqueados procure por https://estapar.innovsign.com.br clique sobre ele e na sequencia clique em Limpar e Redefinir \n" +
                "5 - Tente novamente",
                type: "info",
                closeOnConfirm: true,
            });
        },
    },
    components: {
        pdf,
    }
};
</script>
<style scoped>
    .modal-content {
        min-height: 400px;
    }
    .modal-dialog.modal-lg {
        max-width: 9999999px;
        width: 80%;
        margin-left: 10%;
        margin-right: 10%;
    }

    .controls { 
        margin-left: 10px;
        position: fixed; 
        bottom:0%;
        opacity: 1;
        z-index: 999999999;
        margin-bottom: 20px;
        background-color: white;
        border: 3px solid green;
        padding: 10px;
        border-radius: 25px;
        left: 0;
        right: 0;
    }

    .page-control-label {
        font-size: 23px;
    }

    .no-pending {
        font-size: 40px;
    }

    .fa-check-circle {
        border-radius: 50%;
    }

    .controls { 
        width: 98%;
    }

    .document-mb {
        margin-bottom: 130px;
    }

    .btn-close-modal {
        font-size: 14px;
    }

    @media (max-width: 1199px) {
        .page-control-label {
            margin-bottom: 20px;
        }
    }

    @media (max-width: 600px) {
        .modal-dialog.modal-lg {
            width: 96%;
            margin-left: 2%;
            margin-right: 2%;
        }

        .page-control-label {
            font-size: 15px;
        }

        .controls { 
            width: 95%;
        }

        .no-pending {
            font-size: 30px;
            line-height: 40px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SignatureUser/Pending.vue